import { gql } from 'graphql.macro';
import { connectedLabFragment } from 'apollo/fragments/organization';

export const nameFragment = gql`
    fragment nameFields on Name {
        firstName
        lastName
    }
`;

export const linkedOrganizationFragment = gql`
    fragment linkedOrganizationFields on LinkedOrganization {
        organization {
            _id
            name
            type
            local
            active
            isWhiteLabeled
            connectedLabs {
                ...connectedLabFields
            }
        }
        role
        active
        type
    }
    ${connectedLabFragment}
`;

export const dentistFragment = gql`
    fragment dentistFields on Dentist {
        _id
        fullName
        name {
            ...nameFields
        }
        email
        authMethod
        syncid
        personalIdentityNumber
        title
        phone
        comments
        role
        organization {
            _id
            name
            type
            isWhiteLabeled
            connectedLabs {
                isDisabled
                lab {
                    _id
                    name
                    hexCode
                    textCode
                }
            }
        }
        active
        systemSetting {
            clinic {
                _id
                name
            }
        }
        local
        linkedOrganizations {
            ...linkedOrganizationFields
        }
        whiteLabelAccess
        dentistNotes {
            lab
            clinic
            note
        }
        dentistLocalIds {
            lab
            clinic
            localId
        }
        labDentistDefaultClinics {
            mainClinic
            defaultClinic {
                _id
                name
            }
        }
        enableUserSync
    }
    ${nameFragment}
    ${linkedOrganizationFragment}
`;

export const technicianFragment = gql`
    fragment technicianFields on Technician {
        _id
        fullName
        name {
            ...nameFields
        }
        organization {
            _id
            name
            type
            isWhiteLabeled
            connectedLabs {
                ...connectedLabFields
            }
        }
        email
        role
        active
        isShared
        authMethod
        syncid
        enableUserSync
        personalIdentityNumber
        linkedOrganizations {
            ...linkedOrganizationFields
        }
    }
    ${nameFragment}
    ${linkedOrganizationFragment}
    ${connectedLabFragment}
`;

export const userListFragment = gql`
    fragment userListFields on User {
        _id
        fullName
        name {
            ...nameFields
        }
        type
        syncid
        authMethod
        personalIdentityNumber
        title
        phone
        comments
        role
        organization {
            _id
            name
            type
            isWhiteLabeled
            connectedLabs {
                ...connectedLabFields
            }
        }
        email
        role
        active
        isShared
        systemSetting {
            clinic {
                _id
                name
            }
        }
        local
        linkedOrganizations {
            ...linkedOrganizationFields
        }
        whiteLabelAccess
        enableUserSync
    }
    ${nameFragment}
    ${linkedOrganizationFragment}
    ${connectedLabFragment}
`;
